import React from 'react'
import video from '../assets/bg.mp4'
import About from './About'
import Contact from './Contact'
import Intro from './Intro'
import Navbar from './Navbar'
import Work from './Work'

const Home = () => {
  // video.play()
  return (
    <div>
      <video autoPlay muted loop className='fixed w-[100%] z-[-1]' id='myVideo'>
        <source src={video} type="video/mp4" />
      </video>
     <Navbar/>
     <Intro/>
     <About/>
     <Work/>
     <Contact/>
    </div>
  )
}

export default Home
